import { sv } from '@aldorock-fordon/shared/sv';

/** The Aldorock mark and wordmark (aldorock-design/logo): ink base, navy layer. */
export function Wordmark({ href = '/' }: { href?: string }) {
  return (
    <a className="wordmark" href={href}>
      <svg className="mark" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <rect x="0" y="11" width="24" height="13" fill="currentColor" />
        <rect className="layer" x="9" y="0" width="15" height="9" />
      </svg>
      {sv.app.wordmark}
    </a>
  );
}
